import { trustupWebsocket } from "@deegital/js-trustup-io-websocket";

export default class BaseWebsocketListener
{

    getChannelName()
    {
        // TODO: Find the correct auth key.
        let authKey = window.App.$store.state.user.default_professional.authorization_key;
        console.log('coucou', `professional-${authKey}`);
        return `professional-${authKey}`;
    }

    echo()
    {
        return trustupWebsocket.echo();
    }

    getModels()
    {
        return [];
    }

    init()
    {
        for ( let modelClass of this.getModels() ) {
            this.initModel(modelClass);
        }
    }

    initModel(modelClass)
    {
        if ( typeof modelClass['getEndpoint'] !== 'function' ) {
            console.error('Cannot register listener for model, endpoint function is not defined.', modelClass);
            return;
        }

        if ( modelClass.getEndpoint() == null ) {
            console.error('Cannot register listener for model without endpoint.', modelClass);
            return;
        }

        console.log('Listening to model', {
            model: modelClass,
            created: `.${modelClass.getPrefix()}:created`,
            updated: `.${modelClass.getPrefix()}:updated`,
            deleted: `.${modelClass.getPrefix()}:deleted`
        });

        this.echo().channel( this.getChannelName() )
            .listen(`.${modelClass.getPrefix()}:created`, (e) => {
                this.handleModelCreatedUpdatedEvents(modelClass, e, 'created');
            })
            .listen(`.${modelClass.getPrefix()}:updated`, (e) => {
                this.handleModelCreatedUpdatedEvents(modelClass, e, 'updated');
            })
            .listen(`.${modelClass.getPrefix()}:deleted`, (e) => {
                console.log(e, `.${modelClass.getPrefix()}:deleted`);
                window.App.$bus.$emit(`${modelClass.getPrefix()}:deleted`, e.uuid);
            });
    }

    async handleModelCreatedUpdatedEvents(modelClass, event, eventType)
    {
        console.log(event, `.${modelClass.getPrefix()}:${eventType}`);

        let endpoint = modelClass.getEndpoint().disableModelEvents();

        if ( event.parent ) {
            if ( typeof modelClass['getParentEndpoint'] !== 'function' ) {
                console.error('Cannot handle event for model, parent function is not defined but a parent was given.', modelClass);
                return;
            }

            let parentModel = await modelClass.getParentEndpoint().disableModelEvents().retrieve(event.parent);
            await modelClass.getParentEndpoint().enableModelEvents();
            console.log('Found parent for event:', parentModel);
            endpoint.setParent(parentModel);
        }

        let model = await endpoint.retrieve(event.uuid);
            
        window.App.$bus.$emit(`${modelClass.getPrefix()}:${eventType}`, model);
        modelClass.getEndpoint().enableModelEvents();
    }

}